/******************************************************************
 * Generated by RxDjango on 2026-07-16 09:58 (UTC)                *
 *                                                                *
 * Based on all ContextChannel subclasses in scalar_list.channels *
 *                                                                *
 *                      DO NOT EDIT THIS FILE                     *
 *                                                                *
 * To rebuild it, run:                                            *
 *                                                                *
 *     ./manage.py makefrontend [scalar_list]                     *
 *                                                                *
 ******************************************************************/

import { ContextChannel } from '@rxdjango/react';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class ScalarListChannel extends ContextChannel {

  protected endpoint: string = "/ws/scalar_list/";
  protected baseURL: string = SOCKET_URL;

  items: string[] = ['apple', 'banana', 'cherry'];

  append = async (value: string) => {
    return await this.rx.callAction('append', [value]);
  };

  insert = async (index: number, value: string) => {
    return await this.rx.callAction('insert', [index, value]);
  };

  set_at = async (index: number, value: string) => {
    return await this.rx.callAction('set_at', [index, value]);
  };

  remove_at = async (index: number) => {
    return await this.rx.callAction('remove_at', [index]);
  };

  pop = async () => {
    return await this.rx.callAction('pop', []);
  };

  replace_all = async () => {
    return await this.rx.callAction('replace_all', []);
  };
}
